namespace UPromise {
  export type Maybe<T> = T | Promise<T>;
  export type Awaitable<T> = T | PromiseLike<Awaitable<T>>;

  export const delay = (ms: number) =>
    new Promise<void>((resolve) => setTimeout(resolve, ms));
}

export default UPromise;
